import React from "react";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { IWizardDialogTitleProps, IWizardStepBar } from "../types";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {
  makeStyles,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
} from "@material-ui/core";
import clsx from "clsx";
import IconBar from "./IconBar";

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(0.5),
      color: theme.palette.grey[500],
    },
  });

const useStepBarStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: theme.spacing(51),
    display: "inline-block",
  },
  stepper: {
    backgroundColor: "unset",
    padding: theme.spacing(1.5),
  },
}));

const CustomConnector = withStyles({
  alternativeLabel: {
    top: 16,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  line: {
    height: 2,
    border: 0,
    backgroundColor: "#979797",
    borderRadius: 1,
  },
})(StepConnector);

const useCustomStepIconStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#e1e1e1",
    color: "#757a8a",
    zIndex: 1,
    width: theme.spacing(4),
    height: theme.spacing(4),
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "right",
  },
  active: {
    backgroundColor: "#e6c224",
    color: "#fff",
  },
  completed: {
    backgroundColor: "#7ec884",
    color: "#fff",
  },
  error: {
    backgroundColor: "#ff0000",
    color: "#fff",
  },
}));

function CustomStepIcon(props) {
  const classes = useCustomStepIconStyles();
  const { active, completed, error } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
        [classes.error]: error,
      })}
    >
      {props.icon}
    </div>
  );
}

function StepBar({ steps, activeStepIndex }: IWizardStepBar) {
  const classes = useStepBarStyles();

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStepIndex}
        classes={{ root: classes.stepper }}
        connector={<CustomConnector />}
      >
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel
              StepIconComponent={CustomStepIcon}
              error={step.isInvalid}
            />
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

export const DialogTitle = withStyles(styles)((
  props: IWizardDialogTitleProps,
) => {
  const { classes, onClose, activeStepIndex, steps, ...other } = props;

  const step = steps[activeStepIndex];
  const titleConfig = step.titleConfig;

  return (
    <>
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        {steps.length > 1 && (
          <StepBar steps={steps} activeStepIndex={activeStepIndex} />
        )}
        {steps.length === 1 && titleConfig && (
          <IconBar titleText={titleConfig.titleText} info={titleConfig.info} />
        )}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
      {steps.length > 1 && titleConfig && <IconBar {...titleConfig} />}
    </>
  );
});
